export const TrackingStatusAnalyticsActionTypes = {
    API_RESPONSE_SUCCESS: '@@tracking-status-analytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@tracking-status-analytics/API_RESPONSE_ERROR',
    GET_NO_SHIPMENTS: '@@tracking-status-analytics/GET_NO_SHIPMENTS',
    GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS: '@@tracking-status-analytics/GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS',
    GET_NO_DELIVERED: '@@tracking-status-analytics/GET_NO_DELIVERED',
    GET_NO_UNDELIVERED: '@@tracking-status-analytics/GET_NO_UNDELIVERED',
    GET_NO_EXCEPTIONS: '@@tracking-status-analytics/GET_NO_EXCEPTIONS',
    GET_TRACKING_STATUS: '@@tracking-status-analytics/GET_TRACKING_STATUS',
    GET_TRACKING_STATUS_BY_TIMEFRAME: '@@tracking-status-analytics/GET_TRACKING_STATUS_BY_TIMEFRAME',
    GET_TRACKING_STATUS_SUMMARY: '@@tracking-status-analytics/GET_TRACKING_STATUS_SUMMARY',
};
